import { memo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby-plugin-react-i18next';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { BLOCKS } from '@contentful/rich-text-types';

import ImageDisplay from '../../imageDisplay';

const descOptions = {
	renderNode: {
		[BLOCKS.PARAGRAPH]: (node, children) => (
			<p className="typography typography--body-big typography--tertiary">
				{children}
			</p>
		),
	},
};

const _FeaturedCard = ({ content }) => {
	return (
		<div className="card featured-card">
			<div className="card__head">
				<ImageDisplay
					className="card__head-image"
					alt={content?.image?.alt}
					image={content?.image?.data}
					src={content?.image?.src}
				/>
			</div>
			<div className="featured-card__body">
				<h3 className="featured-card__body-title typography typography--overline typography--tertiary">
					{content?.title}
				</h3>
				<div className="featured-card__body-body">
					{renderRichText(content?.description, descOptions)}
				</div>
				{content?.cta && (
					<Link
						className="featured-card__body-btn btn btn--outlined"
						to={content?.cta?.link}
					>
						{content?.cta?.title}
					</Link>
				)}
			</div>
		</div>
	);
};

_FeaturedCard.propTypes = {
	content: PropTypes.shape({
		image: PropTypes.shape({
			data: PropTypes.object,
			src: PropTypes.string,
			alt: PropTypes.string,
		}),
		title: PropTypes.string,
		description: PropTypes.shape({
			raw: PropTypes.string,
		}).isRequired,
		cta: PropTypes.shape({
			link: PropTypes.string,
			title: PropTypes.string,
		}),
	}).isRequired,
};

_FeaturedCard.defaultProps = {
	content: {},
};

const FeaturedCard = memo(_FeaturedCard);

export default FeaturedCard;
